export function scrubSensitiveText(input:string){
  return input
    .replace(/\b(?:01[016789]|0\d{1,2})[- .]?\d{3,4}[- .]?\d{4}\b/g,'[전화번호 가림]')
    .replace(/\b\d{6}[- ]?[1-4]\d{6}\b/g,'[주민등록번호 가림]')
    .replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi,'[이메일 가림]')
    .replace(/(?:서울|부산|대구|인천|광주|대전|울산|세종|경기|강원|충북|충남|전북|전남|경북|경남|제주)(?:특별자치시|특별자치도|특별시|광역시|도)?\s+[가-힣0-9·.-]+(?:시|군|구)?\s+[가-힣0-9·.-]+(?:로|길|동|가)\s*\d+(?:-\d+)?(?:\s*\d+동\s*\d+호)?/g,'[주소 가림]');
}
